// src/pages/SearchPage.jsx
import React, { useState } from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
// import '../../styles/pages/SearchPage.css';
import '../styles/pages/SearchPage.css';

const SearchPage = () => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      console.log('Searching for:', searchQuery);
    }
  };

  return (
    <div className="search-page">
      <Header />
      
      <main className="search-main">
        {/* Google-like Search Section */}
        <div className="search-container">
          {/* Logo */}
          <div className="search-logo">
            <div className="logo-container">
              <span className="logo-v">V</span>
              <span className="logo-text">Search</span>
            </div>
            <p className="logo-subtitle">Find tools, resources, and help articles</p>
          </div>

          {/* Main Search Bar */}
          <div className="search-section">
            <form onSubmit={handleSearch} className="search-form">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search Vardhman..."
                className="search-input"
                autoFocus
              />
              <button
                type="submit"
                className="search-button"
              >
                <svg className="search-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </button>
            </form>
          </div>

          {/* Quick Search Suggestions */}
          <div className="search-section">
            <h3 className="suggestions-title">Try searching for:</h3>
            <div className="suggestions-grid">
              {[
                'Product Research',
                'Keyword Tools', 
                'Amazon FBA',
                'TikTok Shop',
                'Inventory Management',
                'PPC Automation',
                'Listing Optimization',
                'Analytics Dashboard'
              ].map((term) => (
                <button
                  key={term}
                  onClick={() => setSearchQuery(term)}
                  className="suggestion-button"
                >
                  {term}
                </button>
              ))}
            </div>
          </div>

          {/* Search Results (Placeholder) */}
          <div className="results-container">
            <div className="results-placeholder">
              <svg className="placeholder-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              <p className="placeholder-title">Enter a search term above to find results</p>
              <p className="placeholder-subtitle">Search across all tools, resources, and documentation</p>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default SearchPage;